import {
    IS_DROP_DOWNS_LOADING,
    SET_ALL_REQUEST_TYPE_LIST,
    SET_ASSIGNED_TO_LIST,
    SET_BUYER_NAME_LIST,
    SET_COST_CENTER_LIST,
    SET_REGION_LIST,
    SET_REQUESTED_BY_LIST,
    SET_STATUS_LIST,
    SET_UPDATED_BY_LIST,
    SET_FLEET_PROCESSORS
} from "./OrderGridDropdownsType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_ALL_REQUEST_TYPE_LIST:
            return {
                ...state,
                allRequestTypeList: action.dropdownList,
            };
        case SET_STATUS_LIST:
            return {
                ...state,
                statusList: action.dropdownList,
            };
        case SET_REGION_LIST:
            return {
                ...state,
                regionList: action.dropdownList,
            };
        case SET_COST_CENTER_LIST:
            return {
                ...state,
                costCenterList: action.dropdownList,
            };
        case SET_REQUESTED_BY_LIST:
            return {
                ...state,
                requestedByList: action.dropdownList,
            };
        case SET_ASSIGNED_TO_LIST:
            return {
                ...state,
                assignedToList: action.dropdownList,
            };
        case SET_UPDATED_BY_LIST:
            return {
                ...state,
                updatedByList: action.dropdownList,
            };
        case IS_DROP_DOWNS_LOADING:
            return {
                ...state,
                isDropDownsLoading: action.flag,
            };
        case SET_BUYER_NAME_LIST:
            return {
                ...state,
                buyerNameList: action.buyerNameList
            };
        case SET_FLEET_PROCESSORS:
            return {
                ...state,
                fleetProcessorsList: action.dropdownList,
            }; 
        default:
            return state;
    }
};

export {
    reducers
};